import { UIText2, Responsive, Image } from '@cian/ui-kit';
import { ImagesEmpty16 } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './styles.css';
import { Address } from '../../../containers/AddressContainer';
import { TOffer } from '../../../types/offer';

type TChatHeaderOffer = {
  offer: TOffer;
};

export const ChatHeaderOffer: React.VFC<TChatHeaderOffer> = ({ offer }) => {
  const previewImage = React.useMemo(() => {
    if (offer.photos?.length) {
      return (offer.photos.find(p => p.isDefault) || offer.photos[0])?.miniUrl;
    }

    return '';
  }, [offer]);

  return (
    <div className={styles['container']} data-testid="chat_header_offer">
      <a className={styles['offer']} href={offer.fullUrl} target="_blank">
        <div className={styles['content']}>
          {previewImage ? (
            <Image width={40} height={40} borderRadius="4px" objectFit="cover" src={previewImage} data-testid="image" />
          ) : (
            <div className={styles['empty']} data-testid="empty_image">
              <ImagesEmpty16 color="current_color" />
            </div>
          )}
          <div className={styles['info']}>
            <UIText2>{offer.formattedFullInfo}</UIText2>
            <div className={styles['address']}>{offer.geo && <Address geo={offer.geo} />}</div>
          </div>
        </div>
      </a>
      <Responsive desktop>
        <a className={styles['link']} href={offer.fullUrl} target="_blank" data-testid="show_link">
          <UIText2 color="primary_100">Посмотреть </UIText2>
        </a>
      </Responsive>
    </div>
  );
};
